var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "search_result",
    on: {
      "click": _vm.select
    }
  }, [_c('div', {
    staticClass: "symbol_container"
  }, [_c('p', {
    staticClass: "symbol",
    style: {
      backgroundColor: _vm.chainDarkColor
    }
  }, [_c('span', {
    style: {
      color: _vm.chainColor
    }
  }, [_vm._v("Tx")])])]), _c('div', {
    staticClass: "data"
  }, [_c('p', {
    staticClass: "result_id"
  }, [_vm._v(_vm._s(_vm.item.id))]), _c('div', {
    staticClass: "result_details"
  }, [_c('p', {
    staticClass: "details_ago"
  }, [_vm._v(" " + _vm._s(_vm._f("fromNow")(new Date(_vm.item.timestamp))) + " ")]), _c('p', {
    staticClass: "details_chain",
    style: {
      color: _vm.chainColor
    }
  }, [_vm._v(" " + _vm._s(_vm.chainName) + " ")])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }